import { Box, Typography, Grid } from "@mui/material";
import OrganizationSelector from "./OrganizationSelector";
import { useUserInfoContext } from '../../global/hooks/useUserInfoContext';

//This component is responsible for rendering the OrganizationSelectorLandingView. 
export default function OrganizationSelectorLandingView() {   
    const { userInfo } = useUserInfoContext(); 
    // Display holder for the select dropdown listing all organizations.
    return (
        <>
        <Box sx={{paddingTop: 2, paddingBottom: 2}}>
            <Box sx={{padding: 2, bgcolor: '#F6F8F9'}}>
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 2 }} columns={{ xs: 4, sm: 8, md: 7, lg: 12, xl: 12 }} style={{ display: 'flex' }}>
                <Grid item key={userInfo?.CustomerKey} style={{ display: 'flex' }} xs={12} sm={6} md={6}>
                        <Typography variant="h5" color="black" component="div" sx={{ paddingLeft: 1 }}>{userInfo?.FirstName + " " + userInfo?.LastName}</Typography>
                    </Grid>
                        <OrganizationSelector />
                </Grid>
            </Box>
            </Box>
        </>
    );
}